module.exports = __webpack_public_path__ + "img/num_24.78f4b8a5.png";